import { ReactNode, useState } from 'react';
import { Tooltip, Modal, ModalContent, ModalBody } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { useMediaQuery } from 'usehooks-ts';

interface InformationTooltipProps {
  children: ReactNode;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  size?: number;
}

const InformationTooltip = ({
  children,
  placement = 'right',
  size = 18,
}: InformationTooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (isMobile) {
    return (
      <>
        <span
          className='cursor-help text-default-400 hover:text-default-600'
          onClick={() => setIsOpen(true)}
          role='button'
          tabIndex={0}
        >
          <Icon icon='tabler:info-circle' width={size} />
        </span>

        <Modal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          size='lg'
          classNames={{
            base: 'm-0 p-0',
            wrapper: 'p-4',
          }}
        >
          <ModalContent>
            <ModalBody className='p-6'>
              <div className='text-base'>{children}</div>
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    );
  }

  return (
    <Tooltip
      content={<div className='p-2 max-w-md'>{children}</div>}
      placement={placement}
      showArrow={true}
      classNames={{}}
    >
      <span className='cursor-help text-default-400 hover:text-default-600'>
        <Icon icon='tabler:info-circle' width={size} />
      </span>
    </Tooltip>
  );
};

export default InformationTooltip;
